(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afligember-serveren"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!window.customElements || customElements.get('afligember-serve')) return;
  class Serve extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      if (this.dataset.enabled !== 'true' ||
          (this.dataset.editor === 'true' && this.dataset.preview !== 'true') ||
          !window.IntersectionObserver || !Element.prototype.animate) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (motion.matches) return;
      // De inhoud is standaard zichtbaar, ook zonder JavaScript.
      const copy = this.querySelector('[data-copy]');
      const photo = this.querySelector('figure');
      if (!copy) return;
      const animations = [], watchers = [];
      let timer, stopped = false, copySeen = false, ready = !photo;
      const stop = () => {
        stopped = true;
        clearTimeout(timer);
        watchers.forEach(o => o.disconnect());
        animations.forEach(a => a.cancel());
        motion.removeEventListener('change', change);
      };
      const change = () => { if (motion.matches) stop(); };
      this.cleanup = stop;
      motion.addEventListener('change', change);
      const watch = (el, run) => {
        const o = new IntersectionObserver(entries => {
          if (stopped || !entries.some(e => e.isIntersecting || e.boundingClientRect.bottom < 0)) return;
          o.disconnect();
          run();
        });
        watchers.push(o);
        o.observe(el);
      };
      try {
        const make = (el, frames, duration) => {
          const a = el.animate(frames, { duration, fill:'both', easing:'cubic-bezier(.2,.65,.3,1)' });
          animations.push(a);
          a.pause(); a.currentTime = 0;
          return a;
        };
        const textAnim = make(copy, [{opacity:0}, {opacity:1}], +this.dataset.fade);
        const reveal = () => { if (!stopped && copySeen && ready) textAnim.play(); };
        watch(copy, () => { copySeen = true; reveal(); });
        if (photo) {
          const a = make(photo, [
            {opacity:0, transform:'translateX(-' + this.dataset.distance + 'px)'},
            {opacity:1, transform:'translateX(0)'}
          ], +this.dataset.duration);
          watch(photo, () => {
            a.play();
            a.finished.then(() => {
              if (!stopped) timer = setTimeout(() => { ready = true; reveal(); }, +this.dataset.pause);
            }).catch(() => {});
          });
        }
      } catch (error) { stop(); }
    }
    disconnectedCallback() { this.cleanup?.(); }
  }
  customElements.define('afligember-serve', Serve);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
